<template>
  <div class="earn-wrap">
    <b-container>
      <div class="action-header">
        <KuniMinter
          :is-connected="isConnected"
          :isLoading="isLoading"
          :mData="mData"
          @onClaim="onModalShow('confirm-claim')"
          @onBoost="onModalShow('confirm-ge')"
        />
        <div class="platform-support">
          <div class="description">
            Unlock the ultimate gaming adventure.
            <br />
            <span>Experience the full version now!</span>
          </div>
          <div class="box-right">
            <div class="device-support" @click="onPC">
              <div>
                <img src="~@/assets/icons/globe.svg" />
              </div>
              Available Web/PC
            </div>
            <div class="device-support">
              <div style="display: flex">
                <img class="icon-coming" src="~@/assets/icons/ios.svg" />
                <img class="icon-coming" src="~@/assets/icons/chplay.svg" />
              </div>
              Not Available
            </div>
          </div>
        </div>
      </div>
      <Metamask v-if="!isConnected" />
      <Board v-if="isConnected" @onLoadData="loadData" :mData="mData" />
      <Team v-if="isConnected && isTeam" />
    </b-container>
    <Referral v-if="isConnected" />
    <b-toast
      id="tx-success"
      toast-class="b-success"
      title="Transaction Success"
      solid
      auto-hide-delay="5000"
    >
      Your transaction is successful.
      <b-link
        v-if="chainId && hash"
        :href="utils.linkExplorer(chainId, hash)"
        target="_blank"
      >
        <b>{{ ` View on expolorer` }}</b>
      </b-link>
    </b-toast>

    <b-modal
      id="confirm-claim"
      title="CONFIRMATION"
      body-class="modal-extral-body"
      footer-class="modal-claim-footer"
      centered
    >
      <template #default>
        <p class="extral-desc">
          Claiming {{ utils.bigToCommon(mData.kuniBalance, 18, 2) }} $KUNI will
          reset your Hash Rate. Do you want to continue?
        </p>
      </template>
      <template #modal-footer="{ close }">
        <div class="modal-f-claim">
          <b-overlay
            :show="isClaim"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block o-apply mx-1 w-100"
          >
            <b-btn class="btn-m-custom btn-m-claim w-100" @click="onClaim">
              Yes
            </b-btn>
          </b-overlay>
          <b-btn class="btn-m-custom btn-m-cancel mx-1" @click="close">
            No
          </b-btn>
        </div>
      </template>
    </b-modal>
    <!-- Modal confirm ge -->
    <b-modal
      id="confirm-ge"
      title="CONFIRMATION"
      body-class="modal-extral-body"
      footer-class="modal-claim-footer"
      centered
    >
      <template #default>
        <p class="extral-desc">
          Do you want to burn {{ utils.bigToCommon(mData.ge, 18, 2) }} $GE to
          increase Hash Rate?
        </p>
      </template>
      <template #modal-footer="{ close }">
        <div class="modal-f-claim">
          <b-overlay
            :show="isEarn"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block o-apply mx-1 w-100"
          >
            <b-btn class="btn-m-custom btn-m-claim w-100" @click="onBootsEarn">
              Yes
            </b-btn>
          </b-overlay>
          <b-btn class="btn-m-custom btn-m-cancel mx-1" @click="close">
            No
          </b-btn>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Board from "@/components/Board.vue";
import Referral from "@/components/Referral.vue";
import Metamask from "@/components/Metamask.vue";
import { ERC20, CoreGame } from "@/amakunicom/sdk";
import { ethers } from "ethers";
import { mapGetters } from "vuex";
import KuniMinter from "./KuniMinter.vue";
import Team from "./Team.vue";

const zero = ethers.constants.Zero;

export default {
  name: "Home",
  components: { Board, Referral, Metamask, KuniMinter, Team },
  computed: {
    ...mapGetters("auth", ["isConnected"]),
  },
  data: () => ({
    isTeam: true,
    isLoading: false,
    mData: {
      kuniSymbol: "KUNI",
      kuniBalance: zero,
      aStaked: zero,
      ge: zero,
      bonus: zero,
      stage: ethers.BigNumber.from("1"),
    },
    isClaim: false,
    isEarn: false,
    isLoadData: false,
    chainId: null,
    hash: "",
    reload: 0,
    timer: null,
  }),
  async created() {
    this.tokens = this.getCoreConfig();
    this.chainId = this.tokens.chainId;
    this.$eventBus.$on("metamask-connected", this.onConnectMetamask);
  },
  methods: {
    onModalShow(id) {
      this.$bvModal.show(id);
    },
    async initData() {
      this.signer = await this.provider.getSigner();
      this.account = await this.signer.getAddress();
      this.kuni = await ERC20.initWith(
        this.tokens.kuni,
        this.provider,
        this.signer
      );
      this.game = new CoreGame(this.tokens, this.provider, this.signer);
      this.loadData();
      if (!this.timer) {
        this.timer = setInterval(this.loadData, 20000);
      }
    },
    onPC() {
      window.open(this.tokens.playGame, "_blank");
    },
    async onBootsEarn() {
      try {
        this.isEarn = true;
        const tx = await this.game.earnKuni();
        this.hash = tx.hash;
        this.$bvToast.show("tx-success");
        await tx.wait();
        this.loadData();
      } catch (error) {
        this.$bvToast.toast("KUNI: Unable to process request", {
          variant: "warning",
          autoHideDelay: 3000,
          title: "Warning",
        });
      } finally {
        this.isEarn = false;
        this.$bvModal.hide("confirm-ge");
      }
    },
    async onClaim() {
      try {
        this.isClaim = true;
        const tx = await this.kuni.claim(this.tokens.ge, this.account);
        if (tx) {
          this.hash = tx.hash;
          this.$bvToast.show("tx-success");
          await tx.wait();
          this.loadData();
        }
      } catch (error) {
        this.$bvToast.toast("KUNI: Unable to process request", {
          variant: "warning",
          autoHideDelay: 3000,
          title: "Warning",
        });
      } finally {
        this.isClaim = false;
        this.$bvModal.hide("confirm-claim");
      }
    },
    onConnectMetamask(status) {
      if (status) this.initData();
    },
    loadData() {
      const self = this;
      this.kuni
        .miningInfo(this.tokens.ge, this.account, [
          self.game.m.unclaimedGE(self.account),
          self.game.m.battleBonusOf(self.account),
          self.game.m.stageOf(self.account),
          self.game.amaInv.currentCapOf(self.account),
        ])
        .then(({ symbol, aStaked, aReward, result }) => {
          self.$eventBus.$emit("update-wallet", {
            bonus: result[1],
            stage: result[2],
            cap: result[3],
          });
          self.mData = {
            kuniSymbol: symbol,
            kuniBalance: aReward,
            aStaked,
            ge: result[0],
            bonus: result[1],
            stage: result[2],
          };
          self.isLoading = false;
        });
    },
    goPC() {
      window.open(this.tokens.playGame, "_blank");
    },
  },
  mounted() {
    if (this.isConnected) {
      this.initData();
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.earn-wrap {
  .title {
    color: var(--Red, #eb345f);
    font-family: Bebas Neue;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: 57px;
    line-height: normal;
    margin-bottom: 8px;
  }
  .action-info {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    .btn-earn {
      display: inline-flex;
      height: 48px;
      padding: 8px 20px 8px 12px;
      justify-content: center;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;
      border-radius: 2px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background-color: transparent;
      &:active,
      &:focus {
        box-shadow: none;
      }
      &:disabled,
      &.disabled {
        cursor: not-allowed;
      }
    }
    .btn-action {
      display: flex;
      gap: 15px;
    }

    .box-reward {
      display: flex;
      flex-direction: row;
      .kuni-wrapper {
        &:last-child {
          margin-left: 14px;
        }
      }
    }
  }

  .action-header {
    display: flex;
    justify-content: space-between;
    padding: 32px 0;
    flex-wrap: wrap;
    gap: 16px;
    .platform-support {
      @media (min-width: 376px) and (max-width: 991px) {
        margin: 0px auto;
      }
      display: flex;
      flex-wrap: wrap;
      padding: 16px 0px 16px 16px;
      border-radius: 2px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-left: 8px solid #472f6b;
      align-items: center;
      .description {
        font-size: 16px;
        font-weight: 600;
        line-height: 25px;
        span {
          color: #eb345f;
          text-decoration-line: underline;
        }
      }
      .box-right {
        display: flex;
      }
      .device-support {
        &:last-child {
          border-left: 1px solid rgba(255, 255, 255, 0.2);
          color: rgba(255, 255, 255, 0.2);
          cursor: not-allowed;
        }
        &:first-child {
          cursor: pointer;
        }
        padding: 0 12px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        div {
          img {
            height: 48px;
            width: auto;
            margin: 0 6px;
            &.icon-coming {
              height: 40px;
              margin: 4px 8px;
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .rewards-info,
    .platform-support {
      margin: 0px auto;
    }
  }
  @media (max-width: 767px) {
    .action-header {
      flex-wrap: wrap;
      .platform-support {
        display: none;
      }
    }
    .action-info {
      .btn-kuni {
        width: 100%;
      }
      .btn-action {
        width: 100%;
        .is-claim,
        .is-earn {
          width: calc(50% - 14px);
        }
        .btn-earn {
          width: 100%;
        }
      }
      .box-reward {
        display: flex;
        flex-direction: column;
        width: 100%;
        .kuni-wrapper {
          &:last-child {
            margin-top: 8px;
            margin-left: 0px;
          }
          width: 100%;

          .btn-kuni {
            width: 100%;
          }
        }
      }
    }
    .rewards-info,
    .platform-support {
      width: 100%;
    }
    .action-header {
      .platform-support {
        display: none;
      }
    }
  }

  #confirm-claim {
    .modal-body {
      .extral-desc {
        color: white;
        font-size: 16px;
        font-style: italic;
        font-weight: 400;
        line-height: 24px;
        padding: 8px 32px;
      }
    }
    .modal-footer {
      .claim-action {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
